import { ObjectBase as DataObjectBase } from "../data/ObjectBase";
import { MulticastDelegate } from "./MulticastDelegate";
import { PropertyObservedEventArgs } from "./PropertyObservedEventArgs";
export class PropertyObservable extends DataObjectBase {
  constructor(_eventDelegate = MulticastDelegate, name) {
    super(name);
    this._eventDelegate = _eventDelegate;
    this.propertyChanged = void 0;
    this.propertyChanged = new _eventDelegate(this);
  }

  setValue(propertyName, value) {
    const backingFieldName = `_${propertyName}`;
    const fieldValue = this[backingFieldName];
    if (fieldValue == value || fieldValue != null && typeof fieldValue === 'object' && 'equals' in fieldValue && fieldValue.equals(value)) return false;
    this[backingFieldName] = value;
    this.onPropertyChanged(this, new PropertyObservedEventArgs(propertyName, fieldValue, value));
    return true;
  }

  onReferenceObserved(propertyName, reference, ea) {
    this.onPropertyChanged(this, new PropertyObservedEventArgs(propertyName, reference, reference, ea));
  }

  onValueObserved(propertyName, oldValue, newValue, ea) {
    this.onPropertyChanged(this, new PropertyObservedEventArgs(propertyName, oldValue, newValue, ea));
  }

  onPropertyChanged(sender, ea) {
    this.propertyChanged.invoke(ea);
  }

}
